import React from "react";
import { Text } from "../typography";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { IconExternalLink } from "@amzn/stencil-react-components/icons";
import { I9_ADVANTAGE_URL } from "../../config/urls";
import useArb from "../../hooks/use-arb";

interface I9LegacyProps {
  onLinkClick: () => void;
}

export const I9Legacy = ({ onLinkClick }: I9LegacyProps) => {
  const bundle = useArb("HVHChecklistPantherResource");
  const details = bundle.getMessage("Checklist-MainPage-I9Legacy-H1");
  const begintext = bundle.getMessage("Checklist-MainPage-I9Legacy-BeginText");
  const address = bundle.getMessage("Checklist-MainPage-I9Legacy-Email");
  const pin = bundle.getMessage("Checklist-MainPage-I9Legacy-PIN");
  const buttonText = bundle.getMessage("Checklist-MainPage-I9-ButtonText");
  const supportLink = <a href="https://i9advantage.com/">I9advantage.com</a>;
  const linkMessage = bundle.formatMessage("Checklist-MainPage-I9Legacy-AlternateLink", {
    supportLink: supportLink,
  });
  return (
    <Col gridGap="1rem">
      <Text>
        {details}
        <br />
        <p>{begintext}</p>
        <ul className="task-details">
          <li>{address}</li>
          <li>{pin}</li>
        </ul>
        <p>{linkMessage}</p>
      </Text>
      <Link href={I9_ADVANTAGE_URL} target="_blank" fontSize="T200">
        <Row alignItems="center" gridGap="0.2rem" onClick={onLinkClick}>
          <IconExternalLink />
          {buttonText}
        </Row>
      </Link>
    </Col>
  );
};
